export type AddEnvelopesBatchSummary = {
  insertedTotal: number;
  succeededCount: number;
  failedCount: number;
  firstErrorMessage?: string;
};

export type AddEnvelopesOutcome = {
  refreshEnvelopes: boolean;
  closeModal: boolean;
  message: string;
  isError: boolean;
};

export const buildAddEnvelopesErrorOutcome = (error: unknown): AddEnvelopesOutcome => ({
  isError: true,
  message: error instanceof Error && error.message ? error.message : 'Failed to add messages',
  refreshEnvelopes: false,
  closeModal: false,
});
